<style lang="less" scoped>
@import url('./index.less');
</style>

<template>
  <div class="scroll_view">
    <div class="liyerature_home_container">
      <!-- 顶部弧形 -->
      <div class="top"></div>
      <!-- banner -->
      <div class="banner_wrap" @click="handleBanbenClick">
        <div class="banner_item">
          <!-- <div class="f_title">2019新型冠状病毒肺炎</div>
          <div class="m_title">文献解读</div> -->
          <div class="bottom_wrap" >
            <div v-for="(item,index) in bannerList" :key="index" @click.stop="bannerClickHandle(item)" >
              <div class="number">{{item.count}}</div>
              <div class="txt">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- noticy -->
      <div class="noticy_wrap">
        <div class="new_wrap">NEW!</div>
        <div class="content_wrap">
          <van-swipe style="height: 100%;" vertical autoplay="2000"  :show-indicators="false">
            <van-swipe-item v-for="item in noticyList" :key="item.id">
              <div class="content_item ellipsis_1">
                <span class="van-ellipsis" @click="handleDoDetail(item)">{{item.title}}</span>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div style="width:30px;"></div>
      </div>
      <!-- 数据监控 -->
      <div class="monitoring_container"> 
        <Card title="数据监控" :showMore="false">
          <div class="monitoring_wrap">
            <div class="monitoring_item">
              <div class="literature_tatal">
                <div class="total">{{total}}</div>
                <div class="title">新冠文献总数</div>
              </div>
              <div class="up_wrap">
                <div>
                  <div class="up">+{{up}} {{ up === 0 ? '' : '↑' }}  </div>
                  <div class="up_title">昨日发表数量</div>
                </div>
              </div>
              <div class="line_chart">
                <canvas class="myChart" id="lineChart" ></canvas>
              </div>
            </div>
          </div>
          <div class="footer">
            <div class="fingerpost">
              <img :src="img1"/>
              <div  class="text">
                <div class="title">新冠指南解读</div>
                <div class="otherText">未完待续 敬请期待</div>
              </div>
            </div>
            <!-- <div >
              <img :src="img2"/>
              新冠临床研究
            </div> -->
              <div class="fingerpost">
              <img :src="img2"/>
              <div  class="text">
                <div class="title">新冠临床研究</div>
                <div class="otherText">未完待续 敬请期待</div>
              </div>
            </div>
          </div>
          <!-- <div class="forward_wrap">
            <div class="forward_item"></div>
          </div> -->
          <!-- <div class="forward_guide">
            <div class="title_wrap">
              <div class="guide_title">新冠临床研究</div>
              <div class="forward_label"><span>敬请期待</span></div>
            </div>
            <div class="forward_container">
              <div class="forward_guide_item">
                <div class="guide_number">0</div>
                <div class="guide_title">抗病毒药物治疗</div>
              </div>
              <div class="forward_guide_item">
                <div class="guide_number">0</div>
                <div class="guide_title">干预性实验</div>
              </div>
              <div class="forward_guide_item">
                <div class="guide_number">0</div>
                <div class="guide_title">普通型患者</div>
              </div>
            </div>
          </div> -->
        </Card>
      </div>
      <div class="fill"></div>
      <!-- 数据统计 -->
      <div>
        <Card title="数据统计" :showMore="false" :showData="true" @dataHandle="dataHandle">
          <div class="data_statistical">
            <div>
              <Chart ref="labelChart" :title="'新冠数据类型分布'" :id="'labelChart'" />
            </div>
            <div style="margin-top:0.46rem;">
              <Chart ref="covidChart" :title="'新冠症状分布'" :id="'covidChart'" />
            </div>
            <div style="margin-top:0.46rem;">
              <Chart ref="treatmentChart" :title="'新冠治疗方案分布'" height="700"  id="treatmentChart" />
            </div>
            <div style="margin-top:0.46rem;">
              <Chart ref="basicChart" :title="'新冠基础疾病分布'"  :height="'620'"   :id="'basicChart'" />
            </div>
            <div style="margin-top:0.46rem;">
              <Chart ref="pieChart" :title="'新冠临床分型'" :height="'290'" id="pieChart" />
            </div>

          </div>
        </Card>
      </div>
      <!-- 弹窗 -->
      <div>
        <van-popup
          v-model="show"
          closeable
          round
          close-icon="close"
          :style="{ height: '90%' }"
        >
          <div class="modal_wrap">
              <h2 class="title">数据说明</h2>
              <div class="m_content ">
                <p>本平台所展示的统计图表均来源于{{sum}}篇新冠相关文献数据，数据截止于{{date}}。图表说明如下:</p>
                <div class="modal_item ">
                  <div class="title">• 数据类型分布</div>
                  <div><p>临床注册研究、不同类型文献和指南共识的具体数量。</p></div>
                </div>
                <div class="modal_item ">
                  <div class="title">• 新型冠状病毒肺炎症状分布</div>
                  <div><p>文献中报告的新型冠状病毒肺炎患者的症状分布（例数）。</p></div>
                </div>
                <div class="modal_item ">
                  <div class="title">• 治疗方案分布</div>
                  <div><p>文献中报告的新型冠状病毒肺炎患者的治疗方案使用情况（例数）。</p></div>
                </div>
                <div class="modal_item ">
                  <div class="title">• 基础疾病分布</div>
                  <div><p>文献中报告的新型冠状病毒肺炎患者的合并基础疾病情况（例数）。</p></div>
                </div>
                <div class="modal_item ">
                <div class="title">• 重症比例</div>
                  <div><p>文献中报告的新型冠状病毒肺炎患者的重症与非重症的数量（百分比）。</p></div>
                </div>
              </div>
          </div>
        </van-popup>
      </div>
    </div>
    <FooterLogo/>
    <Back :src="require('../../assets/images/5.png')" @click="handleBack"/>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Popup } from 'vant';
import Card from '@/components/Card'
import Chart from '@/components/chart/Chart'
import F2 from "@antv/f2/lib/index-all"
import { HttpRequest } from 'utils/'
export default {
  data() {
    return {
      show:false,
      bannerList:[],
      up:'',
      total:'',
      lineData:[],
      dataLabel:[],
      otherData:{},
      noticyList:[],
      date:'',
      sum:'',
      img1:require('../../assets/images/2.png'),
      img2:require('../../assets/images/1.png'),
    }
  },
  components:{
    Card,
    Chart,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Popup.name]:Popup
  },
  created() {
    document.title = '学术追踪'
    this.getBannerData()
    this.getMessageData()
    this.getUpData()
    this.getLabelData()
    this.getOtherData()
    this.getNoticyData()
  },
  watch:{
    lineData(val) {
      if(val.length) {
        this.setLineChart(val)
      }
    },
    dataLabel(val) {
      val.length && this.setLabelChart(val)
    },
    otherData(val) {
      if(val) {
        this.setBarChart(val.symptoms,'covidChart')
        this.setBarRowChart(val.treatment,'treatmentChart')
        this.setBarRowChart(val.comorbiditie,'basicChart')
      }
    },
    /**
     * @description 临床分形
     */
    "otherData.servere":{
      handler(val){
        val && this.setPieChart(val)
      },
      deep:true
    }
  },
  methods:{
    handleBack(){
      this.$router.push('/index')
    },
    handleDoDetail(item){
      this.$router.push({
        path:'/academicLiteratureDetail',
        query:{
          order:item.order,
          id:item.id
        }
      })
    },
    async getBannerData() {
      const res = await HttpRequest({
        url:'/academic/get_literature_count/'
      })
      if(res.msg === 'success') {
        this.bannerList = res.data
      }
    },
    async getUpData() {
      const res = await HttpRequest({
        url:'/academic/get_daily_count/'
      })
      if(res.msg === 'success') {
        this.total = res.total
        this.up = res.up
        this.lineData = res.data
      }
    },
    async getLabelData() {
      const res = await HttpRequest({
        url:'/academic/get_type_count/'
      })
      if(res.msg === 'success') {
        this.dataLabel =  res.data
      }
    },
    async getOtherData() {
      const res = await HttpRequest({
        url:'/academic/get_home_statistical/'
      })
      if(res.msg === 'success') {
        this.otherData =  res.data
      }
    },
    async getNoticyData() {
      const res = await HttpRequest({
        url:'/academic/journal_studies/'
      })
      if(res) {
        this.noticyList = res.results
      }
    },
    async getMessageData() {
      const res = await HttpRequest({
        url:'/academic/get_total_count/'
      })
      if(res.msg === 'success') {
        this.date = res.data.date
        this.sum = res.data.num
      }
    },
    dataHandle() {
      this.show = true
    },
    handleBanbenClick(){
      this.$router.push('/academicLiteratureList')  
    },
    bannerClickHandle(item) {
      this.$router.push({
        path:'/academicLiteratureList',
        query:{
          order__in:item.query_condition.order__in.join(',')
        }
      })  
    },
    // 设置折线图
    setLineChart(data) {
      const chart = new F2.Chart({
        id: 'lineChart',
        pixelRatio: window.devicePixelRatio, // 指定分辨率
        padding:0
      });
      chart.source(data);
      chart.tooltip({
        showCrosshairs: true
      });
      chart.scale({
        time: {
          range: [ 0, 1 ]
        },
        tem: {
          tickCount: 5,
          min: 0
        }
      });
      chart.axis('date', {
        label: null,
        grid:null
      });
      chart.axis('count', {
        label: null,
        grid:null
      });
      chart.area().position('date*count').color('#FFDBC4');
      chart.line().position('date*count').color('#FE7922')
      chart.render();
    },
    // 设置文献类型分布图表
    setLabelChart(data) {
      const chart = this.$refs.labelChart.chart
      // 关闭图例
      chart.legend(false)
      chart.tooltip(false)

      // 载入数据源
      chart.source(data.filter(obj=>obj.name));

      // Step 3：创建图形语法，绘制柱状图，由 genre 和 sold 两个属性决定图形位置，genre 映射至 x 轴，sold 映射至 y 轴
      chart
      .interval()
      .position('name*count')
      .color('l(90) 0:#FE7922 1:#FFC099') // 定义柱状图渐变色
      .style({ radius:[3,3,0,0] })
      .size(14)

      // 配置Y轴网格线
      chart.axis('count',{
        grid: {
          lineDash: null,
          stroke: '#F2F2F2',
          lineWidth: 1
        }
      })

      // 横坐标文本样式
      chart.axis('name', {
        label: {
          fill:'#666666'
        }
      });

      // 辅助文本
      data.forEach((obj) => {
        chart.guide().text({
          position: [ obj.name, obj.count ],
          content: obj.count,
          style: {
            textBaseline: 'bottom',
            textAlign: 'center',
            fill:'#FE7922'
          },
          offsetY: -2
        });
      });

      // 渲染图表
      chart.render();
    },
    /**
     * @description 设置可滚动柱状图
     */
    setBarChart(data,id,isScroll = true) {
      var originNames = []
      var otherNames = []
      data.forEach((item,index) => {
        if(index < 5) {
          originNames.push(item.name)
        }else{
          otherNames.push(item.name)
        }
      })
      const chart = this.$refs[id].chart
      // 载入数据源
      chart.source(data,{
        name:{
          type:'cat',
          values:originNames
        },
        count:{
          tickCount:10
        }
      });
      chart.tooltip(false)
      // 配置Y轴网格线
      chart.axis('count',{
        grid: {
          lineDash: null,
          stroke: '#F2F2F2',
          lineWidth: 1
        }
      })
      // 横坐标文本样式
      chart.axis('name', {
        label() {
          return {
            fill:'#666666',
            // 在这里将横坐标显示为 provinceShortName
            // text: data[text].name
          };
        }
      });
      otherNames.forEach((item) => {
        chart.guide().text({
          position: [ item, 'min' ],
          content: item,
          style: {
            textAlign: 'center',
            fontSize:'10',
            fill: '#666666',
            textBaseline: 'bottom'
          },
          offsetX: 0,
          offsetY: 18
        });
      })
      // 辅助文本
      data.forEach((obj) => {
        chart.guide().text({
          position: [ obj.name, obj.count ],
          content: obj.count,
          style: {
            textBaseline: 'bottom',
            textAlign: 'center',
            fill:'#FE7922'
          },
          offsetY: -2
        });
      });

      // Step 3：创建图形语法，绘制柱状图，由 genre 和 sold 两个属性决定图形位置，genre 映射至 x 轴，sold 映射至 y 轴
      chart
      .interval()
      .position('name*count')
      .color('l(90) 0:#FE7922 1:#FFC099') // 定义柱状图渐变色
      .style({
        radius:[3,3,0,0]
      })
      .size(14)


      if(isScroll){
        // 定义进度条
        chart.scrollBar({
          mode: 'x',
          xStyle: {
            backgroundColor: '#e8e8e8',
            fillerColor: '#CCCCCC',
            offsetY: -2
          }
        });
        chart.interaction('pan');
      }
      // 渲染图表
      chart.render();
    },
    /**
     * @description 设置条形图
     */
    setBarRowChart(val,id){
      // const chart = this.$refs.treatmentChart.chart
      const chart = new F2.Chart({
        id: id,
        pixelRatio: window.devicePixelRatio, // 指定分辨率
        appendPadding:[5,10,0,0]
      });
      var data = val.map((item) => {
        return {
          ... item,
          type:'series1'
        }
      })
      data.forEach(item => {
        data.push(
          {
            ... item,
            type:'series2'
          }
        )
      })
      chart.source(data.reverse(), {
        value: {
          tickInterval: 750
        }
      });
      chart.legend(false)
      chart.coord({
        transposed: true
      });
      chart.tooltip(false)
      chart.axis('name',
        {
          grid: null,
          label:null
        });
      chart.axis('count', {
        grid: (txet,index) => {
          if( index === 0) {
            return {
              stroke:'#F2F2F2',
              lineDash:null
            }
          }
          return null
        },
        label: function label(text, index, total) {
          var textCfg = {};
          if (index === 0) {
            textCfg.textAlign = 'left';
          } else if (index === total - 1) {
            textCfg.textAlign = 'right';
          }
          return textCfg;
        }
      });
      data.forEach((obj) => {
         if(obj.type === 'series1') {
           chart.guide().text({
             position: [ obj.name, obj.count ],
             content: obj.count,
             style: {
               textAlign: 'start',
               fill:'#FE7922'
             },
             offsetY: -20,
             offsetX:0
           });
         }else{
          chart.guide().text({
            position: [ obj.name, 0 ],
            content: obj.name,
            style: {
              textAlign: 'start',
              fill:'#333333'
            },
            offsetY: 0,
            offsetX:0
          });
         }
      });
      chart.interval().position('name*count').color('type',['transparent', 'l(0) 0:#FFC099 1:#FE7922'])
      .style({
        radius:[0,3,3,0]
      }).size(16)
      .adjust({
        type: 'dodge',
        marginRatio:2
      });
      chart.render();
    },
    // 设置临床分型
    setPieChart(val) {
      const chart = this.$refs.pieChart.chart
      var data = val.map((item) => {
        return{
          ... item,
          a:'1'
        }
      })
      chart.source(data);
      chart.legend(false);
      chart.tooltip(false);
      chart.coord('polar', {
        transposed: true,
        radius: 0.55,
      });
      // 添加饼图文本
      chart.pieLabel({
        sidePadding: 30,
        label1: function label1(data, color) {
          return {
            text: data.count + '%',
            fill: color
          };
        },
        label2: function label2(data) {
          return {
            text: data.name,
            fill: '#999999',
            lineHeight:20
          };
        }
      });
      chart.axis(false);
      chart.interval().position('a*count').color('name', ['#FF8E2E', '#0D9EE0']).adjust('stack').style({
        lineWidth: 1,
        stroke: '#fff',
        lineJoin: 'round',
        lineCap: 'round'
      }).animate({
        appear: {
          duration: 1200,
          easing: 'bounceOut'
        }
      });

      chart.render();
    }
  }
}
</script>